@if (showMessage) {
  <ion-card class="unauthorised-card">
    <p>{{ 'components.unauthorised-message' | translate }}</p>
  </ion-card>
}
